export default __webpack_public_path__ + "static/media/our-process-06.6bb80bc5.jpg";